import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { OverviewChart } from "components";

const Monthly = () => {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Monthly</h1>
        <p className="text-muted-foreground">
          Monthly sales and performance metrics.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Monthly Overview</CardTitle>
          <CardDescription>
            View monthly sales performance and trends.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-96">
            <OverviewChart view="sales" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Monthly;
